import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(
	theme => ({
		root: {
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			marginBottom: theme.spacing(0.7),
		},
		fiveColumns: {
			[theme.breakpoints.up('lg')]: {
				maxWidth: `calc(20% - ${theme.spacing(4)})`,
				flexBasis: `calc(20% - ${theme.spacing(4)})`,
			},
		},
		image: {
			maxWidth: theme.spacing(21),
			maxHeight: theme.spacing(16),
			width: '100%',
			height: '100%',
			'& picture': {
				display: 'flex',
				justifyContent: 'center',
				alignItems: ({ verticalAlignment }) => verticalAlignment,
			},
			'& img': {
				objectFit: 'contain',
				objectPosition: 'center',
				width: '100%',
			},
		},
	}),
	{ name: 'Content-Content4-Item' },
)

export default useStyles
